import React, { useEffect, useRef, useState } from "react";

/**
 * Custom input-element with its own internal value.
 * @param {*} param0 
 * @returns 
 */
export default function CustomInputElement({ initialValue, handleValueChange, style }) {
  const [value, setValue] = useState(initialValue);

  const inputRef = useRef(null);

  /**
   * Focuses the input-field when being rendered.
   */
  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return <input
    ref={inputRef}
    type="text"
    minLength="3"
    maxLength="100"
    style={style}
    value={value}
    onChange={(event) => setValue(event.target.value)}
    onKeyDown={(event) => {
      if (event.key === "Enter") {
        event.stopPropagation();
        handleValueChange(value);
      }
    }}
    onBlur={() => {
      handleValueChange(value);
    }}
  />
};